/**
 * VerifiedBadge - Shows device verification status
 */

import PropTypes from 'prop-types';
import './VerifiedBadge.css';

const VerifiedBadge = ({ isVerified, isCrossSigned, isVerifying, size = 'medium' }) => {
  if (isVerifying) {
    return (
      <span className={`verified-badge verified-badge--verifying verified-badge--${size}`}>
        <span className="verified-badge__icon">⏳</span>
        <span className="verified-badge__text">Verifying</span>
      </span>
    );
  }

  if (isVerified) {
    return (
      <span className={`verified-badge verified-badge--verified verified-badge--${size}`}>
        <span className="verified-badge__icon">✓</span>
        <span className="verified-badge__text">Verified</span>
      </span>
    );
  }

  return (
    <span className={`verified-badge verified-badge--unverified verified-badge--${size}`}>
      <span className="verified-badge__icon">⚠️</span>
      <span className="verified-badge__text">Not verified</span>
    </span>
  );
};

VerifiedBadge.propTypes = {
  isVerified: PropTypes.bool,
  isCrossSigned: PropTypes.bool,
  isVerifying: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default VerifiedBadge;